interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  id?: string;
}

export function SearchInput({ value, onChange, placeholder, id }: SearchInputProps) {
  return (
    <label className="search-input" htmlFor={id}>
      <svg className="search-input__icon" viewBox="0 0 24 24" aria-hidden="true">
        <path
          d="M10.5 3a7.5 7.5 0 105.25 12.74l4.35 4.35a1 1 0 01-1.42 1.42l-4.35-4.35A7.5 7.5 0 0010.5 3zm0 2a5.5 5.5 0 110 11 5.5 5.5 0 010-11z"
          fill="currentColor"
        />
      </svg>
      <input
        id={id}
        className="search-input__field"
        type="search"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        autoComplete="off"
      />
    </label>
  );
}
